import { render, staticRenderFns } from "./WheelBattleTeamsTab.vue?vue&type=template&id=6f8823bd&scoped=true&"
import script from "./WheelBattleTeamsTab.vue?vue&type=script&lang=js&"
export * from "./WheelBattleTeamsTab.vue?vue&type=script&lang=js&"
import style0 from "./WheelBattleTeamsTab.vue?vue&type=style&index=0&id=6f8823bd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8823bd",
  null
  
)

export default component.exports